import {lazy, Suspense} from "react";
import CircularLoader from "../../customs/loader/main";


const Main = lazy(() => import("../../components/application/changeOfMarital/main"));

const ChangeOfMaritalStatus = () => {

    return(
        <Suspense fallback={<CircularLoader/>}>
            <Main/>
        </Suspense>
    )
};

export default ChangeOfMaritalStatus;